// extracted by mini-css-extract-plugin
export var button = "valuesSection-module--button--b5ea4";
export var buttons = "valuesSection-module--buttons--7058b";
export var buttonsDesktop = "valuesSection-module--buttonsDesktop--69b6d";
export var card = "valuesSection-module--card--677ca";
export var image = "valuesSection-module--image--dfef5";
export var map = "valuesSection-module--map--deb97";
export var text = "valuesSection-module--text--fef61";
export var triangle = "valuesSection-module--triangle--645f6";
export var value = "valuesSection-module--value--aa86a";
export var valueNumber = "valuesSection-module--valueNumber--46a06";
export var valueNumber3 = "valuesSection-module--valueNumber3--172ea";
export var wrapper = "valuesSection-module--wrapper--1eb47";